window._assigneePatientsConfirmShowed =
  window._assigneePatientsConfirmShowed || new Set<string>();

export const addAssigneePatientConfirmShowed = (patientGuid: string) => {
  window._assigneePatientsConfirmShowed?.add(patientGuid);
};

export const isAssigneePatientConfirmShowed = (patientGuid: string) => {
  return window._assigneePatientsConfirmShowed?.has(patientGuid);
};
